import { render, staticRenderFns } from "./ChileCompraSuccess.vue?vue&type=template&id=16031117&scoped=true&"
import script from "./ChileCompraSuccess.vue?vue&type=script&lang=ts&"
export * from "./ChileCompraSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16031117",
  null
  
)

export default component.exports